import { IPopUpData, IPopUpSectionData } from "@pageBuilder/typings";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { PopUpRenderer } from "../pop-up-renderer";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { PopUpSectionCascadeRenderer } from "src/sections/renderers/cascade-renderers/pop-up-section-cascade-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class PopUpCascadeRenderer extends CascadeRendererBase<IPopUpData> {

    protected readonly renderer: PopUpRenderer;
    protected readonly sectionRenderer: PopUpSectionCascadeRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new PopUpRenderer(this.renderingCommonContext);
        this.sectionRenderer = CascadeRendererFactory.create("PopUpSection", this.renderingCommonContext) as PopUpSectionCascadeRenderer;
    }

    public override createByCascade(data: IPopUpData): HTMLElement {
        const element = this.renderer.createNew();
        this.renderer.render(element, data);

        const sectionWrapper = element.querySelector(":scope > .popup-section-wrapper") as HTMLElement;

        if (data.popupSection) {
            const sectionRenderer = CascadeRendererFactory.create("PopUpSection", this.renderingCommonContext) as PopUpSectionCascadeRenderer;
            const sectionElement = sectionRenderer.createByCascade(data.popupSection);
            sectionWrapper.append(sectionElement);
        }

        return element;
    }

    public override getDataByCascade(element: HTMLElement): IPopUpData {
        const sectionElement = element.querySelector(":scope > .popup-section-wrapper > [data-section]") as HTMLElement;
        const sectionCascadeData = this.sectionRenderer.getDataByCascade(sectionElement) as IPopUpSectionData;

        return {
            type: "PopUp",
            id: "pop-up",
            popupSection: sectionCascadeData
        };
    }

}
